/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, needed: NonNullable<unknown>, unit: NonNullable<unknown>, available: NonNullable<unknown>, short: NonNullable<unknown> }} Stock_Out_Shortage_Product_LineInputs */

const vi_stock_out_shortage_product_line = /** @type {(inputs: Stock_Out_Shortage_Product_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}: cần ${i?.needed} ${i?.unit}, còn bán được ở kho mặc định ${i?.available} ${i?.unit} (thiếu ${i?.short} ${i?.unit})`)
};

/**

* @param {Stock_Out_Shortage_Product_LineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_shortage_product_line = /** @type {((inputs: Stock_Out_Shortage_Product_LineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Shortage_Product_LineInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_shortage_product_line(inputs)
});